<template>
    <div class="simple-form">
        <div class="form-group center">
            <div class="form-label">
                <label>审核人：</label>
            </div>
            <div class="form-value width-1-5x">
                <el-select placeholder="请选择" v-model="auditor" :disabled="disabled" :clearable=true>
                    <el-option v-for="item in retailerStaffList" :key="item.name" :label="item.name" :value="item.userId"></el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import retailerApi from '../../api/retailer'

    export default{
        name: 'swb-assign-auditor',
        desc: '指派审核人',
        props: ["userId"],
        data: function () {
            return {
                retailerStaffList: [],
                auditor: null,
                disabled: false
            }
        },
        created: function () {
            //
            if(!Utils.isNoB(this.userId)) {
                this.auditor = this.userId;
                this.disabled = true;
            }
            //
            this.getRetailerStaff();
        },
        methods: {
            getRetailerStaff: function () {
                let self = this;
                let postData = {};
                //
                let msgBoxDlg = MsgBox.loading();
                retailerApi.getRetailerStaffListByComId(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        self.retailerStaffList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                if(!Utils.isNoB(this.auditor)) {
                    result.type = 'info';
                    let data = {};
                    data.disabled = this.disabled;
                    data.auditorId = this.auditor;
                    result.data = data;
                } else {
                    result.type = 'warn';
                    result.message = "请选择审核人";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/AssignAuditor.vue